<template>
  <div :id="'music-list' + compId" class="music-list" :style="musicListComponentStyle.musicList">
    <div class="header-list" v-if="!musicListComponentStyle.disableHeader">
      <div class="search-icon">
        <img @click="dropDownOption()" src="./images/loopka.png" alt="" />
      </div>
      <input
        :style="musicListComponentStyle.headerInput"
        v-model="searchInput"
        type="text"
        placeholder="Szukaj utworu"
      />
    </div>
    <div :class="isVisible ? 'visible' : 'invisible'" class="list" :style="musicListComponentStyle.list">
      <div class="options">
        <ul :style="musicListComponentStyle.ul">
          <li v-for="(item, itemIndex) in filteredMusicByInput" :key="item.id + ' - ' + itemIndex">
            <div class="audio-block" v-if="checkActiveFiltersByName(item)">
              <div class="audio-box" @click="emitSong(item.song, item.secondSong, item.backgroundText, item.title)">
                <img class="play-icon" :src="require('./images/pikto_wroc.svg')" alt="" />
              </div>
              <span
                v-if="!playMusicMode"
                :style="musicListComponentStyle.textBox"
                class="text-box"
                @click="emitSong(item.path, item.secondSong, item.backgroundText, item.title)"
              >
                {{ item.name }}
              </span>
              <span v-else :style="musicListComponentStyle.textBox" class="text-box" @click="playMusic(item.name)">
                {{ item.name }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Howler } from 'howler';
export default {
  name: 'MusicList',
  props: {
    songsList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    musicListComponentStyle: {
      type: Object,
      default: function () {
        return {};
      },
    },
    filtersStatus: {
      type: Object,
      default: function () {
        return {};
      },
    },
    playMusicMode: {
      type: Boolean,
      default: false,
    },
  },
  // mounted() {
  //   this.musicConfig = require('../../config/PsmusicConfig/musicConfig.js');
  // },
  //   @Prop() private musicConfig: any;

  data() {
    return {
      compId: this.getRandomId(),
      searchInput: '',
      isVisible: true,
      enableDropDown: false,
      songs: [],
      audioStatus: [],
    };
  },
  created() {},
  mounted() {
    try {
      this.audioClick = new Howl({
        src: require(`__mainSrcDir/assets/audio/click.mp3`),
        autoplay: false,
        loop: false,
        volume: 0.5,
      });
    } catch (e) {
      console.log(
        '%cAudioPath MusicList- error',
        'font-weight: bold; background: red; color: white; padding: 0px 10px'
      );
    }
    if (this.playMusicMode) {
      this.songsList.forEach((item, index) => {
        this.audioStatus.push(false);
      });

      this.setAudioConfig();
    }
  },
  computed: {
    filteredMusicByInput() {
      const inputMusicSelected = this.searchInput.toLowerCase();
      if (this.searchInput == '') {
        return this.songsList;
      } else {
        return this.songsList.filter((item) => {
          let titleToLower = item.name.toLowerCase();
          if (titleToLower.includes(inputMusicSelected)) return item;
        });
      }
    },
  },
  destroyed() {
    this.songs.forEach((a, index) => {
      this.audioStatus[index] = false;
      a.audio.stop();
    });
  },
  methods: {
    setAudioConfig() {
      this.songs = this.songsList.map((song, index) => {
        song.audio = new Howl({
          src: require(`@/config/PsMusicConfig/${song.path}`),
          onplay: () => {
            // console.log('play');
            this.audioStatus[index] = true;
          },
          onstop: () => {
            // console.log('stop');
            this.audioStatus[index] = false;
          },
          onend: () => {
            // console.log('stop');
            this.audioStatus[index] = false;
          },
        });
        return song;
      });
      // return this.songsList.map((song) => {
      //   song.audio = new Howl({
      //     src: song.path,
      //     onplay: () => {
      //       console.log('gram');
      //       this.audioStatus = true;
      //     },
      //     onend: () => {
      //       console.log('nie gram');
      //       this.audioStatus = false;
      //     },
      //   });
      //   return song;
      // });
    },
    getRandomId() {
      let letters = '0123456789ABCDEFGHIJKLMNOPRSTUW';
      let id_0 = '';
      let id_1 = '';
      let id_2 = '';
      for (let i = 0; i < 6; i++) {
        id_0 += letters[Math.floor(Math.random() * 31)];
        id_1 += letters[Math.floor(Math.random() * 31)];
        id_2 += letters[Math.floor(Math.random() * 31)];
      }
      return id_0 + '-' + id_1 + '-' + id_2;
    },
    checkActiveFiltersByName(item) {
      let isNameActive = false;
      if (this.filtersStatus) {
        if (this.filtersStatus.activeFilterNames?.length > 0) {
          this.filtersStatus.activeFilterNames.forEach((filter) => {
            if (item.tags.includes(filter)) {
              isNameActive = true;
            }
          });
        } else {
          isNameActive = true;
        }
        if (this.filtersStatus.activeFilterGroupsNames?.length > 0) {
          let groupStatus = false;
          this.filtersStatus.activeFilterGroupsNames.forEach((activeGroups) => {
            activeGroups.items.forEach((activeItem) => {
              if (item.tags.includes(activeItem)) {
                groupStatus = true;
              }
            });
          });
          isNameActive = groupStatus && isNameActive;
        }
        return isNameActive;
      }
      return true;
    },
    emitSong(song, secondSong, backgroundText, title) {
      this.audioClick.play();
      this.$emit('emitSong', song, secondSong, backgroundText, title);
    },
    findMusic(path) {
      if (path != '') return require('@/components/musicList' + path);
      return '';
    },
    playMusic(name) {
      // console.log('puszczam muzyke');
      // this.songs.forEach((a) => {
      //   a.audio.stop();
      // });
      this.songs.forEach((a, index) => {
        if (a.name === name) {
          if (this.audioStatus[index] === false) {
            this.audioStatus[index] = true;
            a.audio.play();
          } else {
            this.audioStatus[index] = false;
            a.audio.stop();
          }
        } else {
          this.audioStatus[index] = false;
          a.audio.stop();
        }
      });
    },
    dropDownOption() {
      if (this.enableDropDown) {
        this.isVisible = !this.isVisible;
      } else {
        this.isVisible = true;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.music-list
  position: absolute
  display: flex
  width: 30%
  top: 20%
  left: 30%
  flex-direction: column
  justify-content: flex-start
  .audio-block
    display: flex
    align-items: center
    justify-content: flex-start
    width: 100%
    height: 100%
    &:hover
      text-decoration: underline
      cursor: pointer
    .audio-box
      width: 25px
      height: 25px
      display: inline-block
      img
        transform: scaleX(-1)
    .text-box
      display: flex
      align-items: center
      justify-content: flex-start
      margin-left: 10px
      height: 35px
      width: calc(100% - 70px)
.header-list
  z-index: 10

  box-sizing: border-box

  postion: relative
  width: 100%
  text-align: left
  font-size: 1rem
  background-color: white
  border-top-left-radius: 12px
  border-top-right-radius: 12px
  border-bottom: solid 5px #16b09c
  .search-icon
    width: 44px
    height: 46.5px
    background: #16b09c
    position: absolute
    right: 0
    top: 0
    border-top-right-radius: 12px
    img
      position: absolute
      left: 7px
      top: 7px
  input
    border: none
    outline: none
    margin-top: 2%
    width: 90%
    font-size: 1.1rem
    padding-left: 3%
  .icon
    transform: rotate(0deg)
    transition: all 0.5s ease-in-out
    &.dropdown
      transform: rotate(180deg)
.list

  padding-top: 8px
  padding-left: 12px
  border-bottom-left-radius: 12px
  border-bottom-right-radius: 12px
  box-sizing: border-box

  postion: relative
  width: 100%
  font-size: 2rem
  background-color: #f8fcfb
  visibility: hidden
  transition: all 0.5s linear
  overflow: hidden
  max-height: 0px
  &.visible
    visibility: visible
    max-height: 100%
  ul
    margin: 0%
    padding: 1%
    list-style: none
    text-align: left
    padding-left: 0px
    max-height: 720px
    overflow-y: auto
    overflow-x: hidden
    .audio-block
      font-size: 1rem
      padding: 0.6%
      width: 100%



ul::-webkit-scrollbar-track
  background-color: rgba(0,0,0,0.1)

ul::-webkit-scrollbar
  width: 10px
  background-color: rgba(0,0,0,0.1)

ul::-webkit-scrollbar-thumb
  background-color: #16b09c
  border: 2px solid #16b09c
</style>
